module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.7362/img/provider-ctas-blob-2x.png"